import { cloneElement, useId, type HTMLAttributes, type ReactElement } from "react";
import { Tooltip } from "primereact/tooltip";
import "../Common/Tooltip.scss";

interface ProviderProfileTooltipProps {
  content: string;
  position?: "top" | "bottom" | "left" | "right";
  children: ReactElement<HTMLAttributes<HTMLElement>>;
}

export default function ProviderProfileTooltip({ content, children, position = "right" }: ProviderProfileTooltipProps) {
  const generatedId = useId();
  const id = children.props.id || `profile-tooltip-${generatedId.replace(/:/g, "")}`;

  return (
    <>
      {cloneElement(children, {
        id,
        title: undefined,
        "aria-label": children.props["aria-label"] || content,
      })}
      <Tooltip target={`#${id}`} content={content} className="pbc-profile-tooltip" event="both" position={position} />
    </>
  );
}
